import { DomainProbeStatus } from '@tribeplatform/gql-client/types'

import { Cancel } from './Cancel.js'
import { Commit } from './Commit.js'
import { Revalidate } from './Revalidate.js'

interface Props {
  domain: string
  probeStatus: DomainProbeStatus
  onCommit: () => void
  isCommitting: boolean
  onCancel: () => void
  isCanceling: boolean
  onRevalidate: () => void
  isRevalidating: boolean
}

export const TransferActions = ({
  domain,
  probeStatus,
  onCommit,
  isCommitting,
  onCancel,
  isCanceling,
  onRevalidate,
  isRevalidating,
}: Props) => {
  const isLoading = isRevalidating || isCanceling || isCommitting

  switch (probeStatus) {
    case DomainProbeStatus.Active:
      return null

    case DomainProbeStatus.Pending:
      return (
        <>
          <Revalidate
            isProbing={isRevalidating}
            isLoading={isLoading}
            revalidate={onRevalidate}
          />
          <Cancel
            isCanceling={isCanceling}
            disabled={isLoading}
            cancelTransfer={onCancel}
          />
        </>
      )

    case DomainProbeStatus.ReadyForTransfer:
      return (
        <>
          <Commit
            isCommitting={isCommitting}
            isLoading={isLoading}
            commitTransfer={onCommit}
            domain={domain}
          />
          <Cancel
            isCanceling={isCanceling}
            disabled={isLoading}
            cancelTransfer={onCancel}
          />
        </>
      )

    case DomainProbeStatus.Taken:
    case DomainProbeStatus.Invalid:
    case DomainProbeStatus.Available:
    case DomainProbeStatus.RestrictedFeature:
    case DomainProbeStatus.Reserved:
      return (
        <Cancel
          isCanceling={isCanceling}
          disabled={isLoading}
          cancelTransfer={onCancel}
          isPrimary
        />
      )
    default: {
      const _exhaustiveCheck: never = probeStatus

      return (
        <Cancel
          isCanceling={isCanceling}
          disabled={isLoading}
          cancelTransfer={onCancel}
          isPrimary
        />
      )
    }
  }
}
